import { text } from '@modules/navbar/text';

/** Container path for the app home hub; web maps to `/app`. */
export const NAVBAR_HOME_PATH = '/app';
/** Container path for the dashboard; web maps to `/dashboard`. */
export const NAVBAR_DASHBOARD_PATH = '/dashboard';
export const NAVBAR_CALENDAR_PATH = '/calendar';
export const NAVBAR_GARDENS_PATH = '/gardens';
export const NAVBAR_HARVEST_PATH = '/harvest';
export const NAVBAR_GARDEN_CONFIG_PATH = '/garden-config';
export const NAVBAR_PLANTS_PATH = '/plants';
export const NAVBAR_SETTINGS_PATH = '/settings';
export const NAVBAR_ADMIN_PATH = '/admin';

export type NavbarItem = {
  path: string;
  label: string;
  adminOnly?: boolean;
};

export type ProductScreen = {
  name: string;
  path: string;
  label: string;
  adminOnly?: boolean;
};

export const productScreens: ProductScreen[] = [
  { name: 'dashboard', path: NAVBAR_DASHBOARD_PATH, label: text.dashboardNav },
  { name: 'calendar', path: NAVBAR_CALENDAR_PATH, label: text.calendarNav },
  { name: 'gardens', path: NAVBAR_GARDENS_PATH, label: text.myGardensNav },
  { name: 'harvest', path: NAVBAR_HARVEST_PATH, label: text.harvestNav },
  {
    name: 'garden-config',
    path: NAVBAR_GARDEN_CONFIG_PATH,
    label: text.gardenConfigNav,
  },
  { name: 'plants', path: NAVBAR_PLANTS_PATH, label: text.plantsNav },
  { name: 'settings', path: NAVBAR_SETTINGS_PATH, label: text.settings },
  { name: 'admin', path: NAVBAR_ADMIN_PATH, label: text.adminNav, adminOnly: true },
];

export type BuildNavbarItemsOptions = {
  isAdmin?: boolean;
};

export function buildNavbarItems(options: BuildNavbarItemsOptions = {}): NavbarItem[] {
  const { isAdmin = false } = options;

  return productScreens
    .filter((screen) => !screen.adminOnly || isAdmin)
    .map(({ path, label, adminOnly }) =>
      adminOnly ? { path, label, adminOnly } : { path, label }
    );
}

export function isNavbarItemActive(currentPath: string, itemPath: string): boolean {
  if (itemPath === NAVBAR_HOME_PATH) {
    return currentPath === '/app' || currentPath === '/app/';
  }

  if (itemPath === NAVBAR_DASHBOARD_PATH) {
    return currentPath === '/dashboard' || currentPath === '/dashboard/';
  }

  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
}
